import * as React from 'react'
import s from './header.scss'

export const Header = () => (
  <div className={s.container}>
    <div className={s.title}>Select from list</div>
    <div className={s.subtitle}>Filter seats based on price and location</div>
  </div>
)
